var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"container not-printable",attrs:{"fluid":""}},[_c('SearchStudent',{staticStyle:{"display":"inline-block"},on:{"clicked":_vm.onSearch}})],1),_c('v-container',{staticClass:"container not-printable",attrs:{"fluid":""}},[_c('StudentsTable',{attrs:{"students":_vm.students}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }